import {
  CommonRequest,
  CommonResponse,
  DmlResponse,
  Method,
  ServiceName,
} from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { MdModelCondition, MdModelHeader, MdModelMaster, MdModelSimilar } from 'models/md/MdModel';

/**
 * 기준정보 > 모델 등록/조회 > 모델 그리드 헤더 정보 목록 조회
 * @param elmPrjId
 * @returns
 */
export const findMdModelHeaders = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/model-header`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<MdModelHeader[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdModelHeader[];
};

/**
 * 기준정보 > 모델 등록/조회 > 모델 목록 조회 (사양기준 pivot)
 * @param condition
 */
export const findMdModelBySpec = async (condition?: MdModelCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/model-spec`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<any[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as any[];
};

/**
 * 모델 정보 목록 조회
 * @param condition
 */
export const findMdModel = async (condition?: MdModelCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/model`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<MdModelMaster[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdModelMaster[];
};

/**
 * 기준정보 > 모델 등록/조회 > 모델 정보 저장
 * @param mdModels 모델 목록 조회 (사양기준 pivot)을 통해 조회된 데이터와 동일한 형태
 */
export const saveMdModel = async (mdModels: any[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/model`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: mdModels,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};

/**
 * 기준정보 > 모델 유사도 관리 > 유사도 목록 조회
 */
export const findModelSimilar = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/model-similar`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<MdModelSimilar[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdModelSimilar[];
};

/**
 * 기준정보 > 모델 유사도 관리 > 유사도 목록 저장
 */
export const saveModelSimilar = async (mdModelSimilars: MdModelSimilar[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/model-similar`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: mdModelSimilars,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};
